import * as Sentry from '@sentry/browser';

import { NgModule, ErrorHandler, Inject } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule, Http } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { UpgradeModule } from "@angular/upgrade/static";
import { Store } from '@ngrx/store';
import { AppState } from './app.state';


import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { routerReducer, RouterStoreModule } from '@ngrx/router-store';

import { MainModule } from './main/main.module';
import { appointmentRequestsReducer } from './home/appointment-requests/appointment-requests.reducer';

import { HospitalBookingModule } from './hospital-booking/hospital-booking.module';
import { KioskModule } from './kiosk/kiosk.module';
import { ProfileModule } from "./profile/profile.module";

// Angular 1.5x reducers
import currentPatientReducer from '../main/reducers/current-patient-reducer';
import groupReducer from '../main/reducers/group-reducer';
import notificationsReducer from '../main/reducers/notifications-reducer';
import offeringReducer from '../main/reducers/offering-reducer';
import patientsReducer from '../main/reducers/patients-reducer';
import sessionReducer from '../main/reducers/session-reducer';

// Angular reducers
import { hospitalBookingReducer } from './hospital-booking/store/hospital-booking.reducer';
import { kioskReducer } from './kiosk/kiosk.reducer';
import { appointmentsReducer } from './main/appointments/appointments.reducer';
import { reasonsReducer } from './main/reasons/reasons.reducer';
import { reasonFormReducer } from './main/reasons/reason-form/reason-form.reducer';
import { flashReducer } from './shared/flash/store/flash.reducer';
import { localeReducer } from './main/locale/locale.reducer';

declare var application: any;

import 'zone.js';

class SentryErrorHandler implements ErrorHandler {
    handleError(err: any): void {
    if (application.use.sentryUrl) {
      const exception = err.error || err.message || err.originalError || err;
      Sentry.captureException(exception);
    }
  }
}

@NgModule({
  imports: [
    BrowserModule,
    UpgradeModule,
    MainModule,
    HttpModule,
    HospitalBookingModule,
    ProfileModule,
    KioskModule,
    HttpClientModule,
    StoreModule.provideStore({

      appointments: appointmentsReducer,
      appointmentRequests: appointmentRequestsReducer,
      hospitalBooking: hospitalBookingReducer,
      kiosk: kioskReducer,
      reasons: reasonsReducer,
      reasonForm: reasonFormReducer,

      // Angular 1.5x reducers
      currentPatient: currentPatientReducer,
      group: groupReducer,
      notifications: notificationsReducer,
      offering: offeringReducer,
      patients: patientsReducer,
      session: sessionReducer,
      flash: flashReducer,
      locale: localeReducer,
    }, {
      Router: {
        path: window.location.pathname + window.location.search
      }
    }),
    RouterStoreModule.connectRouter(),
    StoreDevtoolsModule.instrumentOnlyWithExtension(),
  ],
  providers: [
    {
      provide: '$translate',
      useFactory: (i: any) => i.get('$translate'),
      deps: ['$injector']
    },
    {
      provide: '$state',
      useFactory: (i: any) => i.get('$state'),
      deps: ['$injector']
    },
    {
      provide: '$location',
      useFactory: (i: any) => i.get('$location'),
      deps: ['$injector']
    },
    {
      provide: '$ngRedux',
      useFactory: (i: any) => i.get('$ngRedux'),
      deps: ['$injector']
    },
    {
      provide: 'AccountService',
      useFactory: (i: any) => i.get('AccountService'),
      deps: ["$injector"]
    },
    {
      provide: 'PatientsService',
      useFactory: (i: any) => i.get('PatientsService'),
      deps: ['$injector'],
    },
    {
      provide: 'ProductService',
      useFactory: (i: any) => i.get('ProductService'),
      deps: ['$injector'],
    },
    {
      provide: 'LoadingService',
      useFactory: (i: any) => i.get('LoadingService'),
      deps: ['$injector'],
    },
    {
      provide: 'LanguageService',
      useFactory: (i: any) => i.get('LanguageService'),
      deps: ['$injector'],
    },
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler
    },
  ],
  declarations: [
  ],
  entryComponents: [
  ]
})

export default class AppModule {
  constructor(
    private store: Store<AppState>,
  ) {}

  ngDoBootstrap() {}
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/app.module.ts